import { useLayoutEffect, useRef, useState } from 'react';
import { DefaultLoadingManager } from 'three';

import { Flex, Spinner, Typography } from '@spazious/dollhouse-uikit';

import { useDeviceInfo } from '../../hooks/index.js';

export const LoadingBanner = () => {
  const lastTickRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const isMobile = useDeviceInfo(({ isMobile }) => isMobile);
  const loadingThreshold = 1000;
  useLayoutEffect(() => {
    const prevStart = DefaultLoadingManager.onStart;
    const prevLoad = DefaultLoadingManager.onLoad;

    DefaultLoadingManager.onStart = (...args) => {
      prevStart?.(...args);
      lastTickRef.current = performance.now();
      setLoading(true);
    };

    DefaultLoadingManager.onLoad = () => {
      prevLoad?.();
      const minTimeout = Math.max(performance.now() - lastTickRef.current, loadingThreshold);
      setTimeout(() => setLoading(false), minTimeout);
    };

    return () => {
      DefaultLoadingManager.onStart = prevStart;
      DefaultLoadingManager.onLoad = prevLoad;
    };
  });

  if (!loading) {
    return null;
  }
  return (
    <Flex alignItems="center" gap="var(--spacing-gap)">
      {!isMobile && <Typography variant="label">Loading setup... </Typography>}
      <Spinner style={{ scale: 0.3 }} />
    </Flex>
  );
};
